module.exports = __webpack_public_path__ + "static/media/live_tv_outlined.6efdccc7.svg";